export default {
  loadingText: 'Loading data...',
  noDataText: 'No data found',
  itemPerPage: 'Items per page',
  title: {
    create: 'Create New Ingredient',
    edit: 'Edit Ingredient Information',
    detail: 'Ingredient Details'
  },
  label: {
    no: 'Ingredient Code',
    category: 'Category',
    nameCategory: 'Ingredient Category',
    editNameCategory: 'Edit Ingredient Category',
    status: 'Status',
    name: 'Ingredient Name',
    nameTh: 'Ingredient Name',
    nameEn: 'Ingredient Name (EN)',
    nameCn: 'Ingredient Name (CN)',
    brand: 'Brand',
    unitName: 'Ingredient Unit Name',
    unitIngredient: 'Ingredient Unit',
    importUnit: 'Import Unit',
    subUnit: 'Sub Unit',
    pricePerUnit: 'Selling Price (Sub Unit)',
    minQuantity: 'Minimum Quantity (Sub Unit)',
    maxQuantity: 'Maximum Quantity (Sub Unit)',
    note: 'Note',
    remaining: 'Remaining Quantity (Sub Unit)'
  },
  placeholder: {
    search: 'Search by ingredient code or name',
    category: 'Select category',
    status: 'Select status',
    name: 'Enter ingredient name',
    no: 'Enter ingredient code',
    nameEn: 'Enter ingredient name (EN)',
    nameCn: 'Enter ingredient name (CN)',
    brand: 'Enter brand name',
    unitIngredient: 'Enter ingredient unit',
    searchUnitIngredient: 'Search ingredient unit name',
    unitIngredientInfo: 'Enter ingredient unit information',
    importUnit: 'Select import unit',
    subUnit: 'Select sub unit',
    pricePerUnit: 'Enter selling price per sub unit',
    minQuantity: 'Enter minimum quantity',
    maxQuantity: 'Enter maximum quantity',
    note: 'Enter note',
    nameCategory: 'Enter ingredient category name'
  },
  header: {
    no: 'Ingredient Code',
    name: 'Ingredient Name',
    category: 'Category',
    remaining: 'Remaining Quantity',
    status: 'Status'
  },
  tooltip: {
    create: 'Create new ingredient',
    print: 'Print',
    detail: 'View ingredient details',
    edit: 'Edit information',
    delete: 'Delete information',
    importUnit: 'Unit used when importing ingredient into the system',
    subUnit: 'Unit used to deduct stock during sale or usage',
    pricePerUnit: 'Selling price per 1 sub unit',
    minQuantity: 'Minimum stock level of ingredient in system',
    maxQuantity: 'Maximum stock level of ingredient in system',
    remaining: 'Remaining stock of ingredient in system'
  },
  button: {
    cancel: 'Cancel',
    save: 'Save',
    back: 'Back',
    confirm: 'Confirm'
  },
  alert: {
    create: 'Ingredient created successfully!',
    edit: 'Ingredient updated successfully!',
    delete: 'Ingredient deleted successfully!'
  },
  status: {
    all: 'All',
    controlled: 'Within controlled quantity',
    exceed: 'Exceeds controlled quantity',
    lower: 'Below controlled quantity'
  },
  modal: {
    create: {
      title: 'Confirm Ingredient Update',
      subtitle: 'You are updating the ingredient. Do you want to proceed?',
      success: 'Ingredient category added successfully!',
      successUnit: 'Ingredient unit added successfully!'
    },
    edit: {
      title: 'Confirm Ingredient Update',
      subtitle: 'You are updating the ingredient. Do you want to proceed?',
      success: 'Ingredient category updated successfully!',
      unitSuccess: 'Ingredient unit updated successfully'
    },
    delete: {
      title: 'Confirm Ingredient Deletion',
      subtitle: 'You are deleting the ingredient. Do you want to proceed?',
      categoryTitle: 'Confirm Ingredient Category Deletion!',
      categorySubtitle: 'You are deleting an ingredient category. Do you want to proceed?',
      categorySuccess: 'Ingredient category deleted successfully!',
      unitTitle: 'Confirm Ingredient Unit Deletion!',
      unitSubtitle: 'You are deleting an ingredient unit. Do you want to proceed?',
      unitSuccess: 'Ingredient unit deleted successfully!'
    }
  }
}
